import { Routes } from '@angular/router';
import { LayoutComponent, rootRoutes } from '@workspace/ng-aura';
import { adminGuard, NavigationKeys, userAuthGuard } from '@workspace/ng-data-access';
import { discussionRoutes, etxe404Route } from '@workspace/ng-etxe-features';

export const routes: Routes = [
  {
    path: '',
    canActivate: [userAuthGuard, adminGuard],
    component: LayoutComponent,
    data: {
      appName: 'ETXE',
      logoUrl: 'images/logo/logo.svg',
      navigation: {
        key: NavigationKeys.ADMIN_HOME,
      },
    },
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/admin-pages.routes'),
      },
      {
        path: '',
        loadChildren: () => import('./pages/agents/agents.routes').then((m) => m.adminAgentsRoutes),
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/agent-cards/agent-cards.routes').then((m) => m.adminAgentCardsRoutes),
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/properties/properties.routes').then((m) => m.adminPropertiesRoutes),
      },
      {
        path: '',
        loadChildren: () => import('@workspace/ng-routes-features').then((m) => m.adminFeaturesRoutes),
      },
      {
        path: '',
        loadChildren: () => import('@workspace/ng-routes-features').then((m) => [m.helpCenterRoutes]),
      },
      {
        path: '',
        children: discussionRoutes,
      },
      etxe404Route,
    ],
  },
  {
    path: '',
    loadChildren: () => import('@workspace/ng-routes-features').then((m) => [m.authRoutes]),
  },
  {
    path: '',
    loadChildren: () => import('@workspace/ng-routes-features').then((m) => [m.landingRoutes]),
  },
  ...rootRoutes,
];
